import styled from 'styled-components';

export const WidgetContentWrapper = styled.div<{
  highlight?: boolean;
}>`
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  padding-left: 10px;

  &:hover {
    background-color: #f2f8ff;
  }
`;

export const SPIWidgetWrapper = styled(WidgetContentWrapper)`
  .echarts-for-react {
    canvas {
      top: 20px !important;
    }
  }
`;

export const WidgetTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  min-width: fit-content;
  border-radius: 4px;
  padding: 0;
`;

export const WidgetTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #595959;
`;

export const WidgetNumberWrapper = styled.div`
  font-size: 26px;
`;

export const GaugeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StreamNumberWrapper = styled.div`
  font-size: 20px;
`;

export const SPIScoreWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-right: 5px;
`;

export const OppHeader = styled.div`
  text-align: center;
  font-size: 16px;
`;

export const BarGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  gap: 18px;
`;

export const BarWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 3px;
  align-items: center;
  cursor: pointer;
  padding: 0 5px;
  border-radius: 6px;

  .ant-progress {
    margin-bottom: 0;
    margin-inline-end: 0;
  }

  &:hover {
    background-color: #e7f5fe;
  }
`;

export const BarValueLabel = styled.div`
  min-width: 50px;
  font-size: 12px;
  font-weight: 600;
`;

export const BarNameLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  min-width: 145px;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const SessionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-grow: 1;
`;

export const ImpactedSessionsWidgetWrapper = styled.div`
  position: relative;
  border-radius: 4px;
  padding: 3px;
  cursor: pointer;

  &:hover {
    background-color: #f2f8ff;
  }
`;

export const GoodSessionsWidgetWrapper = styled.div`
  position: relative;
  border-radius: 4px;
  padding: 3px;
`;

export const WidgetSubscriptWrapper = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 10px;
  font-weight: 500;
  padding: 5px 0 5px 5px;
  color: #595959;

  span {
    color: black;
    margin-bottom: -3px;
  }
`;

export const MetricTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  color: rgb(0 0 0 / 85%);
  font-size: 16px;
  width: 100px;
  display: flex;
`;
